export class TicketQuantityDisplaySetting {
  id: number;
  isSoldTicket: boolean;

  constructor(isSoldTicket: boolean) {
    this.isSoldTicket = isSoldTicket;
  }
}
